import React from 'react';

import logoLight from 'assets/images/logo.png';
import logoPurple from 'assets/images/logo_purple.png';

const Logo = ({ light }) => {
	return <img src={light ? logoLight : logoPurple} alt='SimSouls' style={{ width: 186, height: 70 }} />;
};

export default Logo;
